// MRS Studios — Collection: infinite scroll + preview-mode fixes
(function () {
  'use strict';

  // Shopify preview mode strips preview_theme_id from paginated/product URLs.
  // Detect it from the current URL and append it where needed.
  var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');

  function withPreview(url) {
    if (!previewId || !url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(previewId);
  }

  // Fix all product card links on the page to keep preview_theme_id
  function fixProductLinks(root) {
    if (!previewId) return;
    var links = (root || document).querySelectorAll('a[href*="/products/"]');
    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (href && href.indexOf('preview_theme_id') === -1) {
        a.href = withPreview(href);
      }
    });
  }

  function initInfiniteScroll() {
    var sentinel = document.getElementById('mrs-scroll-sentinel');
    var loading = document.getElementById('mrs-scroll-loading');
    var grid = document.querySelector('.mrs-collection__grid');
    if (!sentinel || !grid) return;

    // Section Rendering API: Shopify returns only this section's HTML as JSON,
    // avoiding full-page parsing and preview-mode cookie issues.
    var SECTION_ID = 'mrs-collection-grid';
    var isFetching = false;

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || isFetching) return;

      var baseUrl = sentinel.getAttribute('data-next-url') || '';
      if (!baseUrl) {
        observer.disconnect();
        return;
      }

      // Append sections param — response will be JSON {sectionId: htmlString}
      var fetchUrl = baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') + 'sections=' + SECTION_ID;

      isFetching = true;
      if (loading) loading.style.display = 'block';

      fetch(fetchUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var sectionHtml = data[SECTION_ID];
          if (!sectionHtml) throw new Error('section missing from response');

          var parser = new DOMParser();
          var doc = parser.parseFromString(sectionHtml, 'text/html');
          var newGrid = doc.querySelector('.mrs-collection__grid');
          var newSentinel = doc.getElementById('mrs-scroll-sentinel');

          if (newGrid) {
            var newItems = [];
            Array.from(newGrid.children).forEach(function (item) {
              if (!item.classList.contains('mrs-collection__editorial')) {
                fixProductLinks(item);
                grid.appendChild(item);
                newItems.push(item);
              }
            });
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                newItems.forEach(function (el) { el.classList.add('visible'); });
                observer.unobserve(sentinel);
                observer.observe(sentinel);
              });
            });
          }

          var nextNextUrl = newSentinel ? (newSentinel.getAttribute('data-next-url') || '') : '';
          sentinel.setAttribute('data-next-url', nextNextUrl);

          if (loading) loading.style.display = 'none';
          isFetching = false;
        })
        .catch(function (err) {
          console.warn('[mrs-collection] infinite scroll error:', err);
          if (loading) loading.style.display = 'none';
          isFetching = false;
        });
    }, { rootMargin: '600px' });

    observer.observe(sentinel);
  }

  // Intercept product card clicks before view-transitions.js (capture phase, registered early)
  // This prevents the View Transitions API from hijacking navigation to product pages.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.mrs-product-card a[href]');
    if (!link) return;
    e.stopPropagation();
    e.preventDefault();
    window.location.assign(link.href);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fixProductLinks(document);
      initInfiniteScroll();
    });
  } else {
    fixProductLinks(document);
    initInfiniteScroll();
  }
})();
